export default "__VITE_ASSET__f06501eb__"